import React from 'react'
import { defineMessages, injectIntl } from 'react-intl'

const styles = {
  hide: {
    display: 'none',
  },
  show: {
    display: 'block',
    background: '#e0e0e0',
    position: 'fixed',
    bottom: '0',
    zIndex: 1000,
    width: '100%',
  },
  content: {
    padding: '0.5rem 0',
    display: 'block',
    margin: 'auto',
    textAlign: 'center',
    fontSize: '1.5rem',
  },
  button: {
    display: 'inline-block',
    padding: '0 0.5rem',
    fontWeight: '700',
    cursor: 'pointer',
  },
}

const messages = defineMessages({
  cookiesText: {
    id: 'cookies.text',
    defaultMessage: 'Aby bylo legislativě EU učiněno zadost, sdělujeme, že tento web využívá cookies. Pro jistotu taky prohlašujeme, že neobsahuje žádné alergeny.',
  },
  cookiesConfirm: {
    id: 'cookies.confirm',
    defaultMessage: 'Souhlasím',
  },
})

function getCookie(cname) {
  const name = `${cname}=`
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

class CookiesInfo extends React.Component {
  state = {
    isCookiesConfirmed: true,
  }
  componentDidMount() {
    const isCookiesConfirmed = getCookie('cookiesConfirmed')
    this.setState({ isCookiesConfirmed })
  }
  confirmCookie() {
    document.cookie = 'cookiesConfirmed=true; path=/; expires=Thu, 01 Jan 2030 00:00:00 UTC'
    this.setState({ isCookiesConfirmed: true })
  }
  render() {
    const hide = this.state.isCookiesConfirmed
    const intl = this.props.intl
    if (hide) return (<aside />)
    return (
      <aside style={(this.state.isCookiesConfirmed) ? styles.hide : styles.show}>
        <div style={styles.content}>
          {intl.formatMessage(messages.cookiesText)}
          <div onClick={() => this.confirmCookie()}style={styles.button}>{intl.formatMessage(messages.cookiesConfirm)}</div>
        </div>
      </aside>
    )
  }
}

export default injectIntl(CookiesInfo)



// WEBPACK FOOTER //
// ./src/browser/app/CookiesInfo.js